define('viewmodels/pages/cash/NameStepViewModel',['knockout'], function(ko) {

    function NameStepViewModel(depositPage, formFields, player, cardHolder) {

        cardHolder( player.contactInfo.name.fullName() );

        this.field =  formFields.textField(cardHolder);
        this.suggestionText = depositPage.findFieldByName('credit_card_name_suggestion_text');
        this.acceptSuggestion = depositPage.findFieldByName('credit_card_name_accept_suggestion');
        this.rejectSuggestion = depositPage.findFieldByName('credit_card_name_reject_suggestion');
        this.manualText = depositPage.findFieldByName('credit_card_name_manual_text');
        this.manualLabel = depositPage.findFieldByName('credit_card_name_manual_label');
        this.type =  'name';

        this.isManualMode = ko.pureComputed({
            owner: ko.observable(false),
            read: function() {
                return this();
            },
            write: function(value) {

                if (value === true) {
                    cardHolder(null);
                }

                this(value);
            }
        });
    }

    return NameStepViewModel;

});

